import request from '@/utils/request';

const projectName = '/api/blade-platform';

const userMan = {
  state: {
    departmentList: null,
    initData: null,
  },
  mutations: {
    SET_departmentList(state, result) {
      const st = state;
      st.departmentList = result;
    },
    SET_dwgl_initData(state, result) {
      const st = state;
      st.initData = result;
    },
  },
  actions: {
    /**
     * 条件查询校友圈用户列表/查询
     * @param {*} param0 context
     */
    platformalumniuserList({ commit }, data) {
      return request({
        url: `${projectName}/platformalumniuser/list`,
        method: 'post',
        data,
      }).then((res) => {
        // commit('SET_departmentList', res.data.result);
        return Promise.resolve(res);
      });
    },
    /**
     * 获取指定用户动态列表
     * @param {*} param0 context
     */
    getUserDynamic({ commit }, data) {
      return request({
        url: `${projectName}/platformalumniuser/getUserDynamic`,
        method: 'post',
        data,
      }).then((res) => {
        // commit('SET_departmentList', res.data.result);
        return Promise.resolve(res);
      });
    },
    /**
     * 设置禁言
     * @param {*} param0 context
     */
    updateForbidden({ commit }, data) {
      return request({
        url: `${projectName}/platformalumniuser/updateForbidden`,
        method: 'post',
        data,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
    // 屏蔽动态/评论
    shieldDynamics(actions, data) {
        return request({
            url: `${projectName}/platformalumniaction/shield`,
            method: 'post',
            data
        })
    },
    // 屏蔽原因配置
    getReportReason(actions) {
        return request({
            url: `${projectName}/platformalumnireportreasonconfig/getReportReason`,
            method: 'get',
        })
    },
    // 获取指定的动态详情
    getDynamicDetails(actions, data) {
        return request({
            url: `${projectName}/platformalumniaction/getDynamicDetails`,
            method: 'post',
            data
        })
    },
    // 动态获取web名称
    getWebLabel(actions, data) {
        return request({
            url: `${projectName}/platformapplyguiselogo/detail`,
            method: 'get',
        })
    },
  },
};

export default userMan;
